// Define the SlideNumber extension
function SlideNumber(Splide, Components) {
  const { root } = Components.Elements;
  let elm;

  function mount() {
    elm = document.createElement('div');
    elm.className = 'splide__slide-number';
    elm.style.position = 'absolute';
    elm.style.bottom = '10px';
    elm.style.left = '10px';
    elm.style.backgroundColor = 'rgba(0,0,0,0.5)';
    elm.style.color = 'white';
    elm.style.padding = '5px 10px';
    elm.style.borderRadius = '5px';
    elm.style.fontSize = '14px';
    root.appendChild(elm);
    update();
    Splide.on('moved', update);
  }

  function update() {
    elm.textContent = `${Splide.index + 1}/${Splide.length}`;
  }

  return {
    mount,
    destroy() {
      if (elm && elm.parentNode) {
        elm.parentNode.removeChild(elm);
      }
    },
  };
}

// Sets up custom play/pause buttons for Wistia <wistia-player> components (Aurora)
function setupWistiaControls() {
  // All custom control buttons that sit over Wistia players in the main slider
  const wistiaControlButtons = document.querySelectorAll(
    '#main-slider .wistia__content .play-pause__toggle'
  );

  wistiaControlButtons.forEach((button) => {
    // Avoid double-binding if initializeSliders runs more than once
    if (button.dataset.wistiaBound === '1') return;
    button.dataset.wistiaBound = '1';

    const contentWrapper = button.closest('.wistia__content');
    if (!contentWrapper) return;

    const player = contentWrapper.querySelector('wistia-player');
    if (!player) return;

    const accessibilityText = button.querySelector('.visually-hidden');

    const syncButtonState = () => {
      // Aurora exposes .paused (boolean) and .state (e.g., "playing", "paused", "ended")
      const pausedOrEnded = player.paused || player.state === 'ended';
      button.classList.toggle('is-paused', pausedOrEnded);

      const label = pausedOrEnded ? 'Play video' : 'Pause video';
      if (accessibilityText) accessibilityText.textContent = label;
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-pressed', (!pausedOrEnded).toString());
    };

    // Toggle on click
    button.addEventListener('click', (e) => {
      e.preventDefault();
      if (player.paused || player.state === 'ended') {
        player.play();   // Aurora method
      } else {
        player.pause();  // Aurora method
      }
    });

    // Bind after the Aurora API is ready; if it's already ready, bind immediately.
    const bind = () => {
      player.removeEventListener('play', syncButtonState);
      player.removeEventListener('pause', syncButtonState);
      player.removeEventListener('ended', syncButtonState);

      player.addEventListener('play', syncButtonState);
      player.addEventListener('pause', syncButtonState);
      player.addEventListener('ended', syncButtonState);

      // Set initial state
      syncButtonState();
    };

    if (typeof player.state !== 'undefined') {
      // API looks ready; bind now
      bind();
    } else {
      // Aurora readiness signal (replaces legacy whenReady)
      player.addEventListener('api-ready', bind);
    }
  });
}


// Function to initialize sliders
function initializeSliders() {
  var mainSliderElement = document.getElementById('main-slider');
  var thumbnailSliderElement = document.getElementById('thumbnail-slider');

  // Exit if sliders don't exist
  if (!mainSliderElement || !thumbnailSliderElement) {
    return;
  }

  var main = new Splide(mainSliderElement, {
    type: 'slide',
    rewind: false,
    pagination: false,
    arrows: false,
    breakpoints: {
      1024: {},
      768: {
        padding: { right: '5rem' },
      },
    },
  });

  var thumbnails = new Splide(thumbnailSliderElement, {
    fixedWidth: 191,
    fixedHeight: 254,
    height: 746,
    gap: 10,
    rewind: false,
    pagination: false,
    cover: true,
    isNavigation: true,
    direction: 'ttb',
    breakpoints: {
      1024: {
        direction: 'ltr',
      },
      768: {
        destroy: true,
      },
    },
  });

  // Function to pause all Wistia videos
  function pauseAllWistiaVideos() {
    var wistiaEmbeds = document.querySelectorAll('#main-slider .wistia_embed_new');
    wistiaEmbeds.forEach(function (wistiaEmbed) {
      var api = wistiaEmbed;
      if (api) {
        api.pause();
      }
    });
  }

  // Function to play Wistia video in active slide
  function playActiveSlideVideo() {
    var activeIndex = main.index;
    var slides = main.Components.Elements.slides;
    var activeSlide = slides[activeIndex];
    var wistiaEmbed = activeSlide.querySelector('#main-slider .wistia_embed_new');

    if (wistiaEmbed) {
      var api = wistiaEmbed;
      if (api) {
        api.play();
      }
    }
  }

  // Add event listeners for video control
  main.on('move', pauseAllWistiaVideos);
  main.on('moved', playActiveSlideVideo);

  // Sync the sliders
  main.sync(thumbnails);

  // Mount both sliders
  main.mount();
  thumbnails.mount();

  // Add the SlideNumber extension to the main slider
  var slideNumberExtension = new SlideNumber(main, main.Components);
  slideNumberExtension.mount();

  // Optionally, you can add an event listener to destroy the extension if needed
  main.on('destroy', function () {
    slideNumberExtension.destroy();
  });

  // Add logic to handle variant changes
  function setupVariantImageSwitching() {
    const productJsonElement = document.querySelector('[id^="ProductJson-"]');
    if (!productJsonElement) return;

    const productJson = JSON.parse(productJsonElement.textContent);
    const productForm = document.querySelector('form[action="/cart/add"]');
    if (!productForm) return;

    // This function finds the right slide and moves the carousel
    const updateSliderForVariant = (variantId) => {
      if (!variantId) return;

      const selectedVariant = productJson.variants.find(variant => variant.id == variantId);

      if (selectedVariant && selectedVariant.featured_media) {
        const featuredMediaId = selectedVariant.featured_media.id;
        const targetSlide = mainSliderElement.querySelector(`.splide__slide[data-option="${featuredMediaId}"]`);

        if (targetSlide) {
          const slides = Array.from(mainSliderElement.querySelectorAll('.splide__slide'));
          const slideIndex = slides.indexOf(targetSlide);

          if (slideIndex > -1) {
            main.go(slideIndex);
          }
        }
      }
    };

    // Listen for changes from the user
    productForm.addEventListener('change', () => {
      const selectedVariantId = new FormData(productForm).get('id');
      updateSliderForVariant(selectedVariantId);
    });

    // Set the initial slide on page load
    const initialVariantId = new FormData(productForm).get('id');
    updateSliderForVariant(initialVariantId);
  }

  setupVariantImageSwitching();

  // Call the Wistia controls setup
  setupWistiaControls();
}

// Add event listeners
document.addEventListener('DOMContentLoaded', initializeSliders);
document.addEventListener('shopify:section:load', initializeSliders);